import apiClient from 'services/apiClient';

export const getMetaFlowHook = () =>
  apiClient.get('messaging/flow-hook').then((res) => res.data);

export const updateMetaFlowHook = (payload) =>
  apiClient.put('messaging/flow-hook', payload).then((res) => res.data);
